import { ReactNode } from 'react';
import { RoutingRuleTriggerType } from '@mews-commander/data-access';
import { DurationService, lt } from '@mews/framework';
import { StructuredTime, TimeService } from '@optimus-web/core';

export const getTriggerDayTimeValues = (
    processingStartOffset?: string | null
): { triggerDay?: number; triggerTime?: StructuredTime } => {
    const duration = processingStartOffset != null ? DurationService.parse(processingStartOffset) : undefined;
    const triggerDay = duration != null ? DurationService.getDays(duration) + 1 : undefined;
    const triggerHour = duration != null ? DurationService.getHours(duration) : undefined;
    const triggerMinute = duration != null ? DurationService.getMinutes(duration) : undefined;
    const triggerTime =
        triggerHour != null && triggerMinute != null
            ? { hours: triggerHour, minutes: triggerMinute, seconds: 0 }
            : undefined;
    return { triggerDay, triggerTime };
};

export const getTimingDescription = ({
    triggerType,
    processingStartOffset,
    timeService,
    withContinuousDescription = false,
    withLegacyDescription = false,
}: {
    triggerType: RoutingRuleTriggerType;
    processingStartOffset?: string | null;
    timeService: TimeService;
    withContinuousDescription?: boolean;
    withLegacyDescription?: boolean;
}): ReactNode => {
    switch (triggerType) {
        case RoutingRuleTriggerType.Legacy:
            return withLegacyDescription ? lt('RoutingRulesTableTimingLegacyHint') : null;
        case RoutingRuleTriggerType.Recurring: {
            const { triggerDay, triggerTime } = getTriggerDayTimeValues(processingStartOffset);
            const triggerDayTimeTextKey =
                triggerDay === 29 || triggerDay === 30 || triggerDay === 31
                    ? 'RoutingRulesTableTimingRecurringLastDayHint'
                    : 'RoutingRulesTableTimingRecurringHint';
            return triggerDay != null && triggerTime != null
                ? lt(triggerDayTimeTextKey, {
                      day: triggerDay,
                      time: timeService.getShortString(triggerTime),
                  })
                : null;
        }
        case RoutingRuleTriggerType.Continuous: {
            return withContinuousDescription ? lt('RoutingRuleDetailTimingContinuouslyDescription') : null;
        }
        default:
            return null;
    }
};
